var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getIn, useFormik } from 'formik';
import { deepGetFirstNumberOrString } from '../../Shared/ObjectUtilities';
function formikToFormSubmitActions(formik) {
    return {
        validateForm: formik.validateForm,
        setFieldValue: function (field, value, validate) {
            if (validate === void 0) { validate = true; }
            formik.setFieldValue(field, value, validate);
        },
        resetForm: function (values) { return formik.resetForm(values ? { values: values } : undefined); },
        setErrors: formik.setErrors,
        setFieldError: function (field, error) {
            formik.setFieldError(field, error);
        },
        setFieldTouched: function (field, touched, shouldValidate) {
            formik.setFieldTouched(field, touched, shouldValidate);
        }
    };
}
/** Formik form adapter */
export function FormikAdapter(props) {
    var _this = this;
    var formik = useFormik({
        initialValues: props.defaultValues,
        validationSchema: props.validationSchema,
        onSubmit: function (values, actions) { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actions.setSubmitting(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, props.handleSubmit(values, formikToFormSubmitActions(actions))];
                    case 2:
                        _a.sent();
                        actions.setSubmitting(false);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        actions.setSubmitting(false);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); }
    });
    var formikActions = formikToFormSubmitActions(formik);
    return {
        actions: __assign(__assign({}, formikActions), { submitForm: function (formEvent) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // If called from a formContext, dont reload the page
                            if (formEvent) {
                                formEvent.stopPropagation();
                                formEvent.preventDefault();
                            }
                            return [4 /*yield*/, formik.submitForm()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }, registerInput: function (field) { return ({
                value: getIn(formik.values, field),
                onBlur: function () { return formikActions.setFieldTouched(field, true); },
                onChange: function (value) {
                    if (typeof value === 'string') {
                        formikActions.setFieldValue(field, value);
                        return;
                    }
                    formikActions.setFieldValue(field, value.target.value);
                }
            }); }, registerCheckbox: function (field) { return ({
                onBlur: function () { return formikActions.setFieldTouched(field, true); },
                onChange: function (event) { return formikActions.setFieldValue(field, event.target.checked); },
                checked: !!getIn(formik.values, field)
            }); }, registerSelect: function (field) { return ({
                onChange: function (event) {
                    formikActions.setFieldValue(field, event.target.value);
                },
                onBlur: function () { return formikActions.setFieldTouched(field, true); },
                value: getIn(formik.values, field)
            }); }, getFieldValue: function (field) { return getIn(formik.values, field); }, getTouched: function (field) { return getIn(formik.touched, field, false); }, getErrorText: function (field) {
                var error = getIn(formik.errors, field, '');
                var errorText = deepGetFirstNumberOrString(error).toString();
                return errorText;
            }, getMultipleErrorText: function (fields) {
                var errors = fields
                    .map(function (field) {
                    var error = getIn(formik.errors, field, '');
                    return deepGetFirstNumberOrString(error).toString().trim();
                })
                    .filter(function (it) { return !!it; });
                return errors;
            } }),
        state: {
            errors: formik.errors,
            isDirty: formik.dirty,
            isSubmitting: formik.isSubmitting,
            touched: formik.touched,
            values: formik.values,
            isValid: formik.isValid
        },
        context: formik
    };
}
